import { useCallback } from 'react'
import { ButtonSecondary, ButtonPrimary } from '../../../../../../baseComponents/Button'
import { ModalSmallCentered } from '../../../../../../baseComponents/Modal'
import { RowData, TableData } from '../../../../../../baseComponents/TwinTable/types'
import TwinTrans from '../../../../../../baseComponents/TwinTrans'
import { twinFetchPostJSON } from '../../../../../../utils/globals/data'
import { SetEditDeleteModalTy } from '../../../../../../utils/hooks/useEditDeleteModal'


interface ModalMatchProductWorkSheetProps extends ModalMatchProductWorkSheetLogicProps {
}

const ModalMatchProductWorkSheet: React.FC<ModalMatchProductWorkSheetProps> = ({ ...logic }) => {
    const { groupSellOrderProduct, handleOnSubmit } = useModalMatchProductWorkSheetLogic({ ...logic })
    return (
        <ModalSmallCentered opened={true} setOpened={() => logic.setOpenModal(null)} className='modal_skip_operate_stock_order flex_height'>
            <h2 className='mb-20'>
                <TwinTrans transKey={'productWithSameStatusOfProduct'}>Hay un producto con el mismo estado que el producto con referencia </TwinTrans>
                <span>{logic.allRowData.productReference} </span>
            </h2>
            <span className='my-20'><TwinTrans transKey={'groupLinesOrKeepSeparated'}>Puedes juntar las líneas de producto o mantenerlas separadas.</TwinTrans></span>
            <ButtonSecondary onClick={handleOnSubmit} className='mb-10'>
                <TwinTrans transKey={'keepSeparate'}>Mantenerlas separadas</TwinTrans>
            </ButtonSecondary>
            <ButtonPrimary onClick={groupSellOrderProduct}>
                <TwinTrans transKey={'groupLines'}>Juntar las líneas</TwinTrans>
            </ButtonPrimary>
        </ModalSmallCentered>
    )
}

interface ModalMatchProductWorkSheetLogicProps {
    groupProductByStatusURL: string
    allRowData: RowData
    setOpenModal: SetEditDeleteModalTy
    getCompleteData: (inputtable?: TableData) => Promise<void>
    handleProductOnSubmit?: (skipMatchCheck?: boolean | undefined) => Promise<any>
}

const useModalMatchProductWorkSheetLogic = ({ allRowData, groupProductByStatusURL, getCompleteData, setOpenModal, handleProductOnSubmit }: ModalMatchProductWorkSheetLogicProps) => {
    const groupSellOrderProduct = useCallback(async () => {
        const result = await twinFetchPostJSON(groupProductByStatusURL, { WorkSheetProductMatchId: allRowData.WorkSheetProductMatchId, WorkSheetProductId: allRowData.WorkSheetProductId })
        if (result) {
            await getCompleteData()
            setOpenModal(null)
            if (allRowData.setOpened) {
                allRowData.setOpened(null)
            }
        }
    }, [allRowData, groupProductByStatusURL, getCompleteData, setOpenModal])

    const handleOnSubmit = useCallback(async () => {
        if (handleProductOnSubmit) {
            await handleProductOnSubmit(true)
        }
        await getCompleteData()
        setOpenModal(null)
    }, [handleProductOnSubmit, setOpenModal, getCompleteData])

    return { groupSellOrderProduct, handleOnSubmit }
}

export default ModalMatchProductWorkSheet